import React from 'react';
import { Reveal } from './Reveal';
import { categories } from '../data/catalog';
import { useLanguage } from '../contexts/LanguageContext';
export function CategoryGrid() {
  const {
    t
  } = useLanguage();
  const items = t.categories.items as Record<string, {
    title: string;
    meta: string;
  }>;
  return <section id="categorias" aria-labelledby="categorias-title" className="mx-auto max-w-[1520px] scroll-mt-24 px-5 py-20 sm:px-6 sm:py-28 lg:px-14 lg:py-44" data-id="element-13" data-mp="3azdia4wcmf7p">
      <Reveal data-id="element-14" data-mp="7iekyt3wcuba">
        <div className="flex flex-wrap items-end justify-between gap-6 border-b border-line pb-10" data-id="element-15" data-mp="7hvdy7fsbqc1">
          <div data-id="element-16" data-mp="2i91i07s6e4a">
            <p className="text-[11px] uppercase tracking-[0.34em] text-mute" data-id="element-17" data-mp="2hqvibvbglj6">
              {t.categories.eyebrow}
            </p>
            <h2 id="categorias-title" className="mt-5 text-[34px] font-light tracking-[-0.03em] text-white lg:text-[52px]" data-id="element-18" data-mp="3trfu92y1p7bm">
              {t.categories.title}
            </h2>
          </div>
          <a href="#inventario" className="link-underline text-[13px] tracking-wide text-mute transition-colors duration-500 ease-[var(--ease-lux)] hover:text-white" data-id="element-19" data-mp="2lf9xznznjtb0">
            {t.categories.link}
          </a>
        </div>
      </Reveal>

      <ul className="mt-10 grid grid-cols-2 gap-x-4 gap-y-9 sm:mt-16 sm:gap-x-8 sm:gap-y-14 lg:grid-cols-4" data-id="element-20" data-mp="2bj6vgh0w1snj">
        {categories.map((category, i) => {
        const label = items[category.id] ?? {
          title: category.title,
          meta: category.meta
        };
        return <li key={category.id} data-id="element-21" data-mp="26jas8k00m591" data-mpi={i}>
              <Reveal delay={Math.min(i * 0.08, 0.24)} data-id="element-22" data-mp="26jkga21i22c3">
                <a href="#inventario" className="group block" data-id="element-23" data-mp="1srmdsa2an4ow">
                  <div className="overflow-hidden bg-surface" data-id="element-24" data-mp="1xowdqjnb6yqz">
                    <img src={category.image} alt={label.title} loading="lazy" className="aspect-[4/5] w-full object-cover opacity-90 transition-[transform,opacity] duration-[1000ms] ease-[var(--ease-lux)] group-hover:scale-[1.08] group-hover:opacity-100" data-id="element-25" data-mp="1xnblj0ogvrwa" />
                  </div>
                  <div className="mt-4 flex flex-col gap-1 border-t border-line pt-3.5 transition-colors duration-[800ms] ease-[var(--ease-lux)] group-hover:border-guards sm:mt-6 sm:flex-row sm:items-baseline sm:justify-between sm:gap-3 sm:pt-4" data-id="element-26" data-mp="zulojiopyb7o">
                    <h3 className="text-[14px] font-medium leading-tight tracking-tight text-white sm:text-[15px]" data-id="element-27" data-mp="1nm0tzkbsl8n5">
                      {label.title}
                    </h3>
                    <p className="whitespace-nowrap text-[10px] uppercase tracking-[0.18em] text-mute sm:text-[11px]" data-id="element-28" data-mp="1dnb9djsiha37">
                      {label.meta}
                    </p>
                  </div>
                </a>
              </Reveal>
            </li>;
      })}
      </ul>
    </section>;
}